import { teamAvatars } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#1A1C1E] py-24 md:py-36 lg:py-40">
      <div className="w-full px-6 md:px-10 lg:px-16 max-w-6xl mx-auto">

        <p
          className="text-[11px] uppercase tracking-[0.22em] text-[#6C7278]"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
        >
          / About Us
        </p>

        {/* Two-column layout */}
        <div className="mt-12 md:mt-16 flex flex-col lg:flex-row gap-16 lg:gap-24">

          {/* Left: team/workspace image */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative aspect-[4/5] overflow-hidden" style={{ borderRadius: "8px" }}>
              <img
                src="https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/bebb7a85e79564e0801c83128a4e813f.png"
                alt="Trevionix Team"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 border border-white/[0.06]" style={{ borderRadius: "8px" }} />
              {/* Overlay tag */}
              <div
                className="absolute bottom-5 left-5 bg-[#0d0d0d]/80 backdrop-blur-sm px-4 py-3 border border-white/[0.08]"
                style={{ borderRadius: "4px" }}
              >
                <p
                  className="text-[10px] uppercase tracking-[0.16em] text-[#6C7278]"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  Headquartered
                </p>
                <p
                  className="text-sm font-semibold text-white mt-0.5"
                  style={{ fontFamily: "'Public Sans', sans-serif" }}
                >
                  London, United Kingdom
                </p>
              </div>
            </div>
          </div>

          {/* Right: content */}
          <div className="flex-1 flex flex-col justify-center">
            <h2
              className="text-3xl md:text-4xl lg:text-[44px] font-extrabold text-white leading-[1.1] tracking-[-0.02em]"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              Technology Partners.
              <br />
              <span className="text-[#6C7278] font-light">Results Driven.</span>
            </h2>

            <p
              className="mt-8 text-base text-white/60 leading-relaxed"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              We are an IT company specializing in software development for businesses and private users, as well as comprehensive turnkey digital solutions. Our expertise covers several key areas: custom software development, IT consulting, and digital marketing and advertising services.
            </p>
            <p
              className="mt-4 text-base text-white/60 leading-relaxed"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              We help companies not only create technological products but also effectively bring them to market, attract users, and scale their business. We accompany projects at all stages — from idea and analytics to development, launch, and ongoing support.
            </p>
            <p
              className="mt-4 text-base text-white/60 leading-relaxed"
              style={{ fontFamily: "'Public Sans', sans-serif" }}
            >
              Our experienced project managers, developers, UI/UX designers, marketers, and QA engineers work together to combine technology and marketing into a unified growth strategy.
            </p>

            <div className="mt-10 h-px bg-white/[0.06]" />

            <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-10">
              <div className="flex items-center -space-x-2.5">
                {teamAvatars.map((avatar, index) => (
                  <div
                    key={index}
                    className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden border-2 border-[#1A1C1E]"
                  >
                    <img
                      src={avatar}
                      alt={`Team member ${index + 1}`}
                      className="w-full h-full object-cover grayscale"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
              <p
                className="text-sm text-[#6C7278]"
                style={{ fontFamily: "'Public Sans', sans-serif" }}
              >
                Meet our team of{" "}
                <strong className="text-white font-semibold">35+ specialists</strong>{" "}
                &amp; consultants
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center gap-2 text-[12px] font-semibold text-white bg-[#B8422E] px-5 py-2.5 hover:bg-[#9E3826] transition-colors duration-300 whitespace-nowrap"
                style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
              >
                Our Solutions
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 text-[12px] font-semibold text-white border border-white/20 px-5 py-2.5 hover:bg-white hover:text-[#1A1C1E] transition-all duration-300 whitespace-nowrap"
                style={{ fontFamily: "'Space Grotesk', sans-serif", borderRadius: "4px" }}
              >
                Get in Touch
                <i className="ri-mail-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
